/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemmanagement1Inputs */

const en_systemmanagement1 = /** @type {(inputs: Systemmanagement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Management`)
};

const de_systemmanagement1 = /** @type {(inputs: Systemmanagement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systemverwaltung`)
};

/**
* | output |
* | --- |
* | "System Management" |
*
* @param {Systemmanagement1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const systemmanagement1 = /** @type {((inputs?: Systemmanagement1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemmanagement1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_systemmanagement1(inputs)
	return de_systemmanagement1(inputs)
});
export { systemmanagement1 as "systemManagement" }